import React,{useState,useEffect} from 'react';
import post from '../post';
import { formatDate,toPesos } from './Utilities';
const OrderStatus=(props) => {
   const [data,setData]=useState(null);
   const getData=async () => {
            const t=await post('orderStatus',{order_id:props.isOpen});
            if(!t.result){
                props.onClose();
                return;
            }else{
                setData(t.data.data);
            }
    }
    useEffect(() => {
        getData();
        return () => {
            setData(null);
        }
    }, [props.isOpen]);
    if (!props.isOpen) return null;
    const total=data?data.lineas.reduce((acc,linea)=>acc+((+linea.precio)+(+linea.precio_extras))*linea.q,0):'0.00';
    return(
    <div className="fixed inset-0 bg-neutral-950/50 backdrop-blur   flex items-center justify-center z-[1001]">
            <div className="bg-white rounded-md shadow-xl max-w-md w-11/12 p-6 animate-fade-in transform transition-all duration-300 ease-out">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-neutral-900">{props.title??''}</h3>
                    <span className="material-symbols-outlined text-neutral-500 hover:text-neutral-700 cursor-pointer transition-colors"  onClick={props.onClose} >
                        close
                    </span>
                </div>
                <div className="mb-6">
                    {!data && (
                        <div className="flex justify-center mb-4">
                            <div className="w-12 h-12 border-4 border-primary-600 border-t-transparent border-solid rounded-full animate-spin"></div>
                        </div>
                    )}
                    {data && (
                        <>
                        <div className="space-y-4 text-neutral-700">
                            
                           <div className="flex justify-center items-center mb-4">
                             <span className="material-symbols-outlined text-primary-600">{data.tipo=='out' ? 'fastfood' : 'location_on'}</span>
                            <div className="flex-1 mx-4">
                                <small className="text-primary-700">Pedido abierto </small>
                                <p>{data.tipo=='out' ? 'Recoger en sucursal' : 'A domicilio'}</p>
                            </div>
                            </div>
                            <div className="flex items-center space-x-4">
                                <span className="material-symbols-outlined text-primary-600 text-3xl">receipt_long</span>
                                <div>
                                    <p className="text-neutral-800 font-medium">Ticket #{data.ticket}</p>
                                    
                                </div>
                            </div>
                            <div className="flex items-center space-x-4">
                                <span className="material-symbols-outlined text-primary-600 text-3xl">schedule</span>
                                <div>
                                    <p className="text-neutral-800 font-medium">Fecha y Hora</p>
                                    <p className="text-sm text-neutral-600">{formatDate(data.fc)} {data.fc.substring(11, 16)}</p>
                                </div>
                            </div>
                            <hr/>
                        </div>
                        <div className="space-y-2 pt-4">
                            {data.lineas.map((linea,index)=>{
                                const modificadores=JSON.parse(linea.modificadores||'[]');
                                return(
                                <div key={"linea_"+index} className="flex justify-between items-center">
                                    <div className="flex flex-col">
                                        <span className="text-sm text-neutral-900">{linea.q} {linea.nombre}</span>
                                        <div className='ms-4'>
                                            {modificadores.map((mod,ix)=>(
                                                <span key={"mod_"+index+"_"+ix} className="text-xs text-neutral-500">
                                                    {mod.opts.map((o,i)=>(
                                                        <span key={"opt_"+index+"_"+ix+"_"+i}>
                                                            {o.value} {o.nombre}
                                                        </span>
                                                    ))}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    <span className="font-medium text-neutral-900">${toPesos(((+linea.precio)+(+linea.precio_extras))*linea.q)}</span>
                                </div>
                            )})}
                        </div>
                        </>
                    )}
                    <hr/>
                    <div className='flex justify-between items-center mt-4'>
                        <span className="text-lg font-semibold text-neutral-900">Total</span>
                        <span className="text-lg font-semibold text-neutral-900">${data?toPesos(total):'0.00'}</span>
                    </div>
                </div>
                <button 
                    className="w-full bg-primary-600 text-white py-3 rounded-xl font-medium hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                    onClick={props.onClose}    
                >
                    Cerrar
                </button>
                {/* Next: "Add a subtle progress indicator" */}
            </div>
        </div>
    );
}

export default OrderStatus;